<template>
  <div class="select-tag">
    {{ label }}
    <div
      class="select-tag__icon"
      data-testid="icon-remove"
      @click.stop="$emit('remove')"
    >
      <WIcon icon="icClear" />
    </div>
  </div>
</template>
<script>
import { WIcon } from '@alice-health/wonderland-vue'
export default {
  components: { WIcon },
  props: {
    label: {
      type: String,
      required: true
    }
  },
  emits: ['remove']
}
</script>
<style lang="scss" scoped>
.select-tag {
  display: inline-flex;
  align-items: center;
  padding: var(--gl-spacing-01) var(--gl-spacing-02);
  gap: var(--gl-spacing-02);
  border: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-20);
  border-radius: var(--gl-border-radius-xs);
  font-size: var(--gl-font-size-xxs);
  &__icon {
    cursor: pointer;
  }
}
</style>
